import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "preferences_panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"onoffswitch onoffswitch_pref\" style=\"margin:0 5px;\"><input type=\"checkbox\" class=\"onoffswitch-checkbox\" id=\"cb_invert_scroll_wheel\"><label class=\"onoffswitch-label onoffswitch-label_pref\" for=\"cb_invert_scroll_wheel\"><span class=\"onoffswitch-inner\"></span><span class=\"onoffswitch-switch onoffswitch-switch_pref offstate\"></span></label></div>", 1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "row"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('preferences.invert_scroll')), 1),
      _hoisted_4
    ]),
    (_ctx.config.enable_statistics)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("a", {
            class: "primary link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.displayStatisticsScreen && _ctx.displayStatisticsScreen(...args)))
          }, _toDisplayString(_ctx.t('preferences.statistics')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.labeling)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", {
            target: "_blank",
            class: "primary link",
            href: _ctx.labeling.user_manual
          }, _toDisplayString(_ctx.t('preferences.user_manual')), 9, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    (_ctx.labeling)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("a", {
            target: "_blank",
            class: "primary link",
            href: _ctx.labeling.about
          }, _toDisplayString(_ctx.t('preferences.about_galen', { productName: _ctx.productName })), 9, _hoisted_9)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
        class: "primary link"
      }, _toDisplayString(_ctx.t('preferences.sign_out')), 1)
    ])
  ]))
}